import { fetchMainApi } from '@/api';

export const getOrder = async (
  orderId,
  endpoint,
  alongRoute,
  routeRadius,
  destinationRadius,
  pickupRadius
) => {
  const params = new URLSearchParams();
  if (alongRoute !== undefined) params.append('alongRoute', alongRoute.toString());
  if (routeRadius !== undefined) params.append('routeRadius', routeRadius.toString());
  if (destinationRadius !== undefined) params.append('destinationRadius', destinationRadius.toString());
  if (pickupRadius !== undefined) params.append('pickupRadius', pickupRadius.toString());

  const queryString = params.toString();
  const url = queryString ? `/${endpoint}/${orderId}?${queryString}` : `/${endpoint}/${orderId}`;

  return await fetchMainApi('GET', url);
};

export const getOrderPublic = async (
  orderId,
  alongRoute,
  routeRadius,
  destinationRadius,
  pickupRadius
) => {
  const params = new URLSearchParams();
  if (alongRoute !== undefined) params.append('alongRoute', alongRoute.toString());
  if (routeRadius !== undefined) params.append('routeRadius', routeRadius.toString());
  if (destinationRadius !== undefined) params.append('destinationRadius', destinationRadius.toString());
  if (pickupRadius !== undefined) params.append('pickupRadius', pickupRadius.toString());

  const queryString = params.toString();
  const url = queryString ? `/listings/public/${orderId}?${queryString}` : `/listings/public/${orderId}`;

  return await fetchMainApi('GET', url);
};

export const getOrderPublicValidate = async (orderId, token) => {
  const params = new URLSearchParams({ orderId: orderId.toString(), token });
  return await fetchMainApi('GET', `/listings/public/validate/${orderId}/${token}?${params.toString()}`);
};

export const getOrders = async (params, endpoint) => {
  const searchParams = new URLSearchParams();

  // Add all parameters to search params
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach(item => searchParams.append(key, item.toString()));
      } else {
        searchParams.append(key, value.toString());
      }
    }
  });

  const queryString = searchParams.toString();
  const url = queryString ? `/${endpoint}?${queryString}` : `/${endpoint}`;

  return await fetchMainApi('GET', url);
};

export const takeLoadCRMRequest = async (dto) => {
  return await fetchMainApi('POST', '/listings/crm/request', { body: JSON.stringify(dto) });
};

export const changeOrderStatus = async (crmId, dto) => {
  return await fetchMainApi('POST', `/listings/${crmId}/status`, { body: JSON.stringify(dto) });
};

export const downloadDispatchSheet = async (crmId) => {
  const response = await fetch(`${process.env.VUE_APP_API_HOST || ''}/api/listings/${crmId}/dispatch-sheet`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
      'Accept': 'application/json'
    },
    credentials: 'include'
  });

  if (!response.ok) {
    throw new Error(`Download failed: ${response.status}`);
  }

  const contentType = response.headers.get('content-type') || '';
  const contentDisposition = response.headers.get('content-disposition') || '';

  // Extract filename from content-disposition header
  let originalName = 'dispatch-sheet.pdf';
  const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
  if (filenameMatch && filenameMatch[1]) {
    originalName = filenameMatch[1].replace(/['"]/g, '');
  }

  const blob = await response.blob();

  return {
    file: new Blob([blob], { type: contentType }),
    originalName
  };
};

export const getOrderForAcceptance = async (uuid) => {
  return await fetchMainApi('GET', `/orders/${uuid}/accept-load`);
};

export const acceptOrder = async (uuid, data) => {
  return await fetchMainApi('POST', `/orders/${uuid}/accept`, { body: JSON.stringify(data) });
};

export const declineOrder = async (uuid, data) => {
  return await fetchMainApi('POST', `/orders/${uuid}/decline`, { body: JSON.stringify(data || {}) });
};

export const dispatchOrder = async (orderId, data) => {
  return await fetchMainApi('POST', `/carloads/${orderId}/dispatch`, { body: JSON.stringify(data) });
};

export const undispatchOrder = async (orderId) => {
  return await fetchMainApi('POST', `/carloads/${orderId}/undispatch`);
};

export const cancelOrder = async (uuid) => {
  return await fetchMainApi('POST', `/orders/${uuid}/cancel`);
};

export const addOrderToFavorites = async (uuid) => {
  return await fetchMainApi('POST', `/carloads/${uuid}/favorite`);
};

export const removeOrderFromFavorites = async (uuid) => {
  return await fetchMainApi('DELETE', `/carloads/${uuid}/favorite`);
};

export const addDispatcher = async (uuid, accountContactId) => {
  return await fetchMainApi('POST', `/orders/${uuid}/dispatcher`, { body: JSON.stringify({ account_contact_id: accountContactId }) });
};

export const removeDispatcher = async (uuid) => {
  return await fetchMainApi('DELETE', `/orders/${uuid}/dispatcher`);
};

export const addDriver = async (uuid, accountContactId) => {
  return await fetchMainApi('POST', `/orders/${uuid}/driver`, { body: JSON.stringify({ account_contact_id: accountContactId }) });
};

export const removeDriver = async (uuid) => {
  return await fetchMainApi('DELETE', `/orders/${uuid}/driver`);
};

export const assignDispatcherUser = async (uuid, dispatcherUserId) => {
  return await fetchMainApi('POST', `/orders/${uuid}/dispatcher`, { body: JSON.stringify({ dispatcher_user_id: dispatcherUserId }) });
};

export const assignDriverUser = async (uuid, driverUserId) => {
  return await fetchMainApi('POST', `/orders/${uuid}/assign-driver`, { body: JSON.stringify({ driver_user_id: driverUserId }) });
};

export const unassignDriverUser = async (uuid) => {
  return await fetchMainApi('POST', `/orders/${uuid}/unassign-driver`);
};

export const addTruck = async (uuid, truckId) => {
  return await fetchMainApi('POST', `/orders/${uuid}/truck`, { body: JSON.stringify({ truck_id: truckId }) });
};

export const removeTruck = async (uuid) => {
  return await fetchMainApi('DELETE', `/orders/${uuid}/truck`);
};
